var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("这是子组件")]),_vm._v(" "),_c('input',{attrs:{"type":"text","placeholder":"请输入"}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("myslot",null,{"data":_vm.list})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0bab55e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/demo/son.vue
// module id = null
// module chunks = 